var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stepCount" }, [
    _vm.brandTemplate !== "generic_2"
      ? _c("div", { staticClass: "titles" }, [
          _c("p", { staticClass: "step-number" }, [
            _vm._v(_vm._s(_vm.$t("Account.CreateAccount.Registration")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.currStepTitle))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentStep !== 5
      ? _c(
          "div",
          { staticClass: "steps" },
          _vm._l(_vm.steps, function(step, i) {
            return _c(
              "v-btn",
              {
                key: step.stepNo,
                class: [
                  _vm.currentStep > step.stepNo ||
                  (_vm.currentStep < step.stepNo && !_vm.steps[i].isDisabled)
                    ? "btnStepVisited"
                    : "btnStep"
                ],
                attrs: {
                  small: "",
                  id: "stepNo" + step.stepNo,
                  disabled: _vm.steps[i].isDisabled
                },
                on: {
                  click: function($event) {
                    return _vm.jump2Step(step.stepNo)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.brandTemplate !== "generic_2" ? step.stepNo : "")
                )
              ]
            )
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72174db0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72174db0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Registration/RegStepCounter.vue
// module id = null
// module chunks = 